import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { getPatient } from '../../store/calendar/CalendarThunk'
import {
  ADD_TO_SCHEDULE_SUCCESS,
  EDIT_SCHEDULE_SUCCESS,
  GET_APPOINTMENT_SUCCESS,
  GET_CURRENT_SCHEDULE_SUCCESS,
} from '../../store/calendar/CalendarConstants'
import { getTabId } from '../../utils/common'

export const CalendarPageListener = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowEditPopUpView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowPNBView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowAvailabilityView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsNeedToResetRecurrence,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  refreshSchedule,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  updateSchedule,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action, listenerApi) => {
          const currentTabId = getTabId()

          switch (action.type) {
            case GET_APPOINTMENT_SUCCESS:
              if (action.extraData.shouldShowLoading) {
                // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
                listenerApi.dispatch(getPatient(action.payload.PatientId, action.extraData.shouldShowLoading))
              }
              break
            case ADD_TO_SCHEDULE_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                setIsNeedToResetRecurrence(true)
                setShowPNBView(false)
                setShowAvailabilityView(false)
                refreshSchedule()
              }
              break
            case EDIT_SCHEDULE_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                setIsNeedToResetRecurrence(true)
                setShowEditPopUpView(false)
                refreshSchedule()
              }
              break
            case GET_CURRENT_SCHEDULE_SUCCESS:
              if (currentTabId !== action.extraData.tabId) {
                updateSchedule(action.extraData.from, action.extraData.to, action.payload)
              }
              break
            default:
              break
          }
        },
      }),
    )
    // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
    return () => unsubscribe()
  }, [refreshSchedule, updateSchedule])

  return null
}
